import { render } from "./HoupiaoDetailDrawer.vue?vue&type=template&id=004c67e2&ts=true"
import script from "./HoupiaoDetailDrawer.vue?vue&type=script&lang=ts"
export * from "./HoupiaoDetailDrawer.vue?vue&type=script&lang=ts"

import "./HoupiaoDetailDrawer.vue?vue&type=style&index=0&id=004c67e2&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__